import React from "react";

type ToothSelectorProps = {
  toothNumbers: string[];
  onToothClick: (tooth: number) => void;
};

const upperTeethA = [18, 17, 16, 15, 14, 13, 12, 11];
const upperTeethB = [21, 22, 23, 24, 25, 26, 27, 28];
const lowerTeethA = [48, 47, 46, 45, 44, 43, 42, 41];
const lowerTeethB = [31, 32, 33, 34, 35, 36, 37, 38];

const ToothSelector: React.FC<ToothSelectorProps> = ({
  toothNumbers,
  onToothClick,
}) => {
  const renderRow = (teeth: number[]) => (
    <div className="w-full flex justify-evenly items-center py-1">
      {teeth.map((tooth) => (
        <button
          key={tooth}
          type="button"
          className={`w-4 h-4 md:w-6 md:h-6 text-xs md:text-sm rounded ${
            toothNumbers.includes(tooth.toString())
              ? "bg-[#2fa9bf] text-white"
              : "bg-white"
          }`}
          onClick={() => onToothClick(tooth)}
        >
          {tooth}
        </button>
      ))}
    </div>
  );

  return (
    <div className="bg-white h-full w-full flex flex-col text-sm md:text-lg px-0 md:px-[2%] py-1">
      <div className="flex flex-col md:flex-row">
        {renderRow(upperTeethA)}
        <div className="w-1 md:w-1.5 bg-[#2fa9bf]"></div>
        {renderRow(upperTeethB)}
      </div>
      <div className="w-full h-1 bg-[#2fa9bf] mt-2 md:mt-0"></div>
      <div className="flex flex-col md:flex-row mt-2 md:mt-0">
        {renderRow(lowerTeethA)}
        <div className="w-1 md:w-1.5 bg-[#2fa9bf]"></div>
        {renderRow(lowerTeethB)}
      </div>
    </div>
  );
};

export default ToothSelector;
